import { render, staticRenderFns } from "./ni-icon-edit.vue?vue&type=template&id=e4a3eec4"
import script from "./ni-icon-edit.vue?vue&type=script&lang=js"
export * from "./ni-icon-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports